'use strict';

const Analytics = require('./analytics');

class AnalyticsPromotions extends Analytics {
    init (globalContainer, helperContainer) {
        this.logName = 'Analytics Promotions & Info';
        super.init(globalContainer, helperContainer);

        this.prepareObservers();
        this.pushLandingInteraction();
    }

    fillPositions () {
        let container = $('.analytics-promotion');

        for (let i = 0; i < container.length; i++) {
            let obj = container.eq(i);
            obj.attr('data-index', i);
        }
    }

    getPromotionItem (element) {
        let obj = element.data();
        obj.promotion_id = this.helper.format4DigitNumber(obj.position);
        obj.promotion_name = this.helper.formatString(obj.name);
        obj.creative_name = element.closest('.slick-list').length > 0 ? 'slider' : 'boxes';
        return obj;
    }

    getPromotionsList () {
        let items = [];
        let container = $('.analytics-promotion');

        for (let i = 0; i < container.length; i++) {
            if ($($('.analytics-promotion')[i]).closest('.tab-content').length !== 0) {
                if ($($('.analytics-promotion')[i]).closest('.current').length !== 0) {
                    let obj = this.getPromotionItem(container.eq(i));
                    items.push(obj);
                }
            } else {
                let obj = this.getPromotionItem(container.eq(i));
                items.push(obj);
            }
        }

        return items;
    }

    pushLandingInteraction () {
        this.fillPositions();

        let promotions = this.getPromotionsList();
        this.quickImpressionSender.pushPromotionListImpression(promotions);
    }

    pushClickInteraction (element) {
        this.fillPositions();

        let item = this.getPromotionItem(element);
        this.quickImpressionSender.pushPromotionClickImpression(item);
    }

    prepareObservers () {
        var _self = this;

        $('.tab-link').on('click', function (e) {
            var tab = e.currentTarget.dataset.tab;
            $('#' + tab).addClass('current');
            _self.pushLandingInteraction();
        });

        // Promotion
        $('.analytics-promotion').on('click touchstart', function (e) {
            _self.pushClickInteraction($(this));
        });

        // Info Banner
        $('body').on('click', '.analytics-infoBanner-actions', function (e) {
            let action = _self.helper.formatString($(e.currentTarget).data('analytics-action')); 
            let name = $(e.currentTarget).closest('.cc-promoStrip__slide__wrp').data('analytics-promo');
            _self.quickImpressionSender.pushInfoBannerClickImpression(action, name);
        });

        // Customer Service - Link
        $('.analytics-customer-service-link').on('click', function (e) {
            _self.quickImpressionSender.pushCustomerServiceItemClick(_self.helper.formatString($(this).data('name')));
        });

        // Customer Service - Popular Questions
        $('.analytics-customer-service-popular-questions').on('click', function (e) {
            if ($(e.currentTarget).closest('.accordion-item').hasClass('active')) {
                return;
            }
            _self.quickImpressionSender.pushCustomerServicePopularQuestionItemClick(_self.helper.formatString($(this).data('name')));
        });

        // Customer Service - Question in topic page
        $('.analytics-customer-service-accordion').on('click', function (e) {
            if ($(e.currentTarget).closest('.accordion-item').hasClass('active')) {
                return;
            }
            let question = _self.helper.formatString($(this).data('name') || '');
            let topic = _self.helper.formatString($('.analytic-customer-service-topic').data('name') || '');
            _self.quickImpressionSender.pushCustomerServiceItemExpand(topic, question);
        });
    }
}

const obj = new AnalyticsPromotions();
module.exports = obj;
